import Accordion from '@/components/accordion/accordion'
import ShoppingCartToggle from '@/components/shopping-cart-toggle/shopping-cart-toggle'
import StorePicker from '@/components/header/components/store-picker/store-picker'

const NavMobile = {
  components: {
    'accordion': Accordion,
    'shopping-cart-toggle': ShoppingCartToggle,
    'store-picker': StorePicker
  },
  data () {
    return {
      isToggled: false,
    };
  },
  methods: {
    handleToggle: function(value) {
      document.querySelector('html').classList.toggle('nav-mobile--active', value)
      this.isToggled = value
    },
  },
  created () {
    bus.$on('nav_toggled', (isActive) => {
      this.handleToggle(isActive)
    })
  },
}


export default NavMobile
